import ReactMarkdown from "react-markdown";
import userIcon from "./images/usericon.png"
import diyoraAvatar from "./images/diyoraAvatar.gif"


function Message({ messages, messagesEndRef }) {
    // console.log("bu habar",messages)
    return messages.map((message, index) => (
        <div  className={`chat-msg ${message.owner === 'user' ? "owner" : "" }`} key={index}>
            <div className="chat-msg-profile">
                <img className="chat-msg-img" src={ message.owner === 'user' ? userIcon : diyoraAvatar } alt="" />
            </div>
            <div className="chat-msg-content">
                <div className="chat-msg-text"><ReactMarkdown>{ message.content }</ReactMarkdown></div>
            </div>
       </div>
    ));
}

export default Message;